import Axios from 'axios';
import { getAccessToken , getSessionAccessToken } from './helper';


export const ENVIRONMENTS = {
    DEV: "dev",
    PROD: "prod",
    LOCAL: "local",
} as const;

type Environment = (typeof ENVIRONMENTS)[keyof typeof ENVIRONMENTS];

// Read environment from .env file
export const ENVIRONMENT: Environment = ((process.env.ENVIRONMENT || "dev").toLowerCase()) as Environment;

// Get API URL based on environment
const getApiUrl = (): string => {
    switch (ENVIRONMENT) {
        case ENVIRONMENTS.DEV:
            return process.env.APIURL_DEV;
        case ENVIRONMENTS.PROD:
            return process.env.APIURL_PROD;
        case ENVIRONMENTS.LOCAL:
            return process.env.APIURL_LOCAL;
        default:
            return process.env.APIURL_DEV;
    }
};

export const API_BASE_URL = getApiUrl();
export const DEFAULT_TOKEN = process.env.DEFAULT_TOKEN || '';

export const axiosBase = Axios.create({ baseURL: API_BASE_URL });

axiosBase.interceptors.request.use(
    async config => {
        // 1. Primary auth token from localStorage (set by login API)
        try {
            const raw = localStorage.getItem('AUTHDATA');
            if (raw) {
                const auth = JSON.parse(raw);
                if (auth?.authToken) {
                    config.headers.Authorization = `Bearer ${auth.authToken}`;
                }
            }
        } catch {  }
        try {
            const sessionRaw = sessionStorage.getItem('TS');
            if (sessionRaw) {
                const sessionAuth = JSON.parse(sessionRaw);
                const sessionToken = sessionAuth?.authToken;
                if (sessionToken) {
                    config.headers['x-session-token'] = sessionToken;
                }
            }
        } catch {  }

        return config;
    },
    error => Promise.reject(error)
);


axiosBase.interceptors.response.use(
    response => response,
    error => {
        const data = error?.response?.data;
        const isExpired = error?.response?.status === 403 && data?.code === 'SUBSCRIPTION_EXPIRED';
        const method = (error?.config?.method || '').toLowerCase();
        const isWrite = ['post', 'put', 'patch', 'delete'].includes(method);
        if (isExpired && isWrite && typeof window !== 'undefined' && !window.location.pathname.startsWith('/pricing')) {
            window.location.assign('/pricing');
        }
        return Promise.reject(error);
    }
);

export const errorHandler = (error: any) => {
    if (error.response) {
        return error.response.data
    } else if (error.message) {
        return { errorMessage: error.message }
    } else {
        return { errorMessage: "Something went wrong" }
    }
}

